import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { ViewContainersService } from './shared/services/view-containers.service';
import { Observable } from 'rxjs';
import { ActionState, ComponentConfig, ComponentState, LoadingState, SelectedValue,BreadCrumbData, Relation, OutGoingLink, ComponentTask } from './shared/model';
import { tap,concatMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UbsComponentStoreService  extends ComponentStore<ComponentState> {

  constructor(private viewContainerService:ViewContainersService) { 
    super({
      workSpaceState:"",
      callState:LoadingState.INIT,
      firstVisit:true,
      action:ActionState.LIST,
      componentConfig:null,
      selectedValue:null,
      breadCrumbs:null,
      activeLevel:1,
      selectedRelation:null,
      selectedMasterDetail:null,
      outGoingLink:null
    })
  }

  //Selectors
  readonly componentConfig$:Observable<ComponentConfig> = this.select(state => state?state.componentConfig:undefined)
  readonly selectedWorkSpace$:Observable<String> = this.select(state => state?state.workSpaceState:undefined);
  readonly firstVisit$:Observable<Boolean> = this.select(state => state?state.firstVisit:undefined);
  readonly action$:Observable<String> = this.select(state => state?state.action:undefined);
  readonly selectedValue$:Observable<SelectedValue> = this.select(state => state?state.selectedValue:undefined);
  readonly breadCrumbs$:Observable<BreadCrumbData[]> = this.select(state => state?state.breadCrumbs:undefined);
  readonly activeLevel$:Observable<number> = this.select(state => state?state.activeLevel:undefined);
  private readonly loading$: Observable<boolean> = this.select(
    state => state?.callState === LoadingState.LOADING
  );
  readonly selectedRelation$:Observable<Relation> = this.select(state => state?state.selectedRelation:undefined);
  readonly selectedMasterDetail$:Observable<Relation> = this.select(state => state?state.selectedMasterDetail:undefined);
  readonly selectedTask$:Observable<ComponentTask> = this.select(state => state?state.selectedTask:undefined);
  readonly outGoingLink$:Observable<OutGoingLink> = this.select(state => state?state.outGoingLink:undefined);

  // ViewModel for the component
  readonly vm$ = this.select(
    this.selectedWorkSpace$,
    this.firstVisit$,
    this.action$,
    this.componentConfig$,
    this.selectedValue$,
    this.breadCrumbs$,
    this.activeLevel$,
    this.loading$,
    this.selectedRelation$,
    this.selectedMasterDetail$,
    this.selectedTask$,
    this.outGoingLink$,
    (workSpaceState,firstVisit,action,componentConfig,selectedValue,breadCrumbs,activeLevel,loading,selectedRelation,selectedMasterDetail,selectedTask, outGoingLink) => ({
      workSpaceState,
      firstVisit,
      action,
      componentConfig,
      selectedValue,
      breadCrumbs,
      activeLevel,
      loading,
      selectedRelation,
      selectedMasterDetail,
      selectedTask,
      outGoingLink
    })
  );

  //Updaters
  readonly updateWorkSpaceState = this.updater((state:ComponentState,menuItemTitle:string) => {
    return {
      ...state,
      workSpaceState:menuItemTitle
    }
  })
  readonly updateFirstVisit = this.updater((state:ComponentState,status:boolean) => {
    return {
      ...state,
      firstVisit:status
    }
  });

  readonly updateAction = this.updater((state:ComponentState,action:string) => {
    console.log({TrackActionUpdate:{action:action}})
    const actionState = action as ActionState;
    switch (actionState) {
      case ActionState.ADD:
        return {
          ...state,
          action:ActionState.ADD
        }
        break;
      case ActionState.DELETE:
        return {
          ...state,
          action:ActionState.DELETE
        }
        break;
      case ActionState.EDIT:
        console.log({"Setting Action":actionState})
      return {
        ...state,
        action:ActionState.EDIT
      }
      break;
      case ActionState.FIND:
        return {
          ...state,
          action:ActionState.FIND
        }
        break;
      case ActionState.LIST:
        return {
          ...state,
          action:ActionState.LIST
        }
        break;
      case ActionState.VIEW:
        return {
          ...state,
          action:ActionState.VIEW
        }
        break;
      case ActionState.RELATE:
        return {
          ...state,
          action:ActionState.RELATE
        }
        break;
      case ActionState.TASKSACTRSLT:
        return {
          ...state,
          action:ActionState.TASKSACTRSLT
        }
        break
      default:
        break;
    }
    
  });

  readonly updateComponentConfig = this.updater((state:ComponentState,componentConfig:ComponentConfig) => {
    return {
      ...state,
      componentConfig:componentConfig
    }
  });

  readonly updateSelectedValue = this.updater((state:ComponentState,selectedValue:SelectedValue) => {
    console.log(selectedValue);
    return {
      ...state,
      selectedValue:selectedValue
    }
  })

  readonly updateBreadCrumbs = this.updater((state:ComponentState,breadCrumbs:BreadCrumbData[]) => {
    return {
      ...state,
      breadCrumbs:breadCrumbs
    }
  })

  readonly updateActiveLevel = this.updater((state:ComponentState,activeLevel:number) => {
    return {
      ...state,
      activeLevel:activeLevel
    }
  })

  readonly updateSelectedRelation = this.updater((state:ComponentState,selectedRelation:Relation) => {
    return {
      ...state,
      selectedRelation:selectedRelation
    }
  })

  readonly updateSelectedMasterDetail = this.updater((state:ComponentState,selectedMasterDetail:Relation) => {
    console.log("Track MasterDetail",selectedMasterDetail)
    return {
      ...state,
      selectedMasterDetail:selectedMasterDetail
    }
  })

  readonly updateSelectedTask = this.updater((state:ComponentState,selectedTask:ComponentTask) => {
    console.log("Track MasterDetail",selectedTask)
    return {
      ...state,
      selectedTask:selectedTask
    }
  })

  readonly updateAppContext = this.updater((state:ComponentState,appContext:string) => {
    return {
      ...state,
      appContext:appContext
    }
  })
  readonly setLoading = this.updater((state: ComponentState) => {
    return {
      ...state,
      callState: LoadingState.LOADING
    };
  });

  readonly setLoaded = this.updater((state: ComponentState) => {
    return {
      ...state,
      callState: LoadingState.LOADED
    };
  });

  readonly updateOutGoingLink = this.updater((state:ComponentState,outGoingLink:OutGoingLink) => {
    return {
      ...state,
      outGoingLink:outGoingLink
    }
  })

  //Effects
  readonly setActiveLevel = this.effect((activeLevel$:Observable<number>) => {
    return this.activeLevel$.pipe(
      tap<number>((activeLevel:number) => {
        this.updateActiveLevel(activeLevel$);
      })
    )
    })

 /*  readonly setTitleAndCompConfig = this.effect((componentConfig$:Observable<ComponentConfig>,workSpaceState$:Observable<>) => {
    return this.state$.pipe(
      tap(() => {
        this.updateComponentConfig(componentConfig);
        this.updateWorkSpaceState(title);
       
      })
    )
  }) */

}

export function getEnumKeyByEnumValue<T extends {[index:string]:string}>(myEnum:T, enumValue:string):keyof T|null {
  let keys = Object.keys(myEnum).filter(x => myEnum[x] == enumValue);
  return keys.length > 0 ? keys[0] : null;
}
